import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { actions } from 'src/actions';
import { AppUser } from 'src/types';

export type State = {
  data: AppUser[];
  total: number;
};

const initialState: State = {
  data: [],
  total: 0,
};

const reducer = reducerWithInitialState<State>(initialState).cases(
  [actions.api.users.getUsers.done],
  (state, payload): State => ({
    ...state,
    data: payload.result.result,
    total: payload.result.count,
  })
);
// forceLogout API returns { success, message }; list refresh is handled in usersSaga (getUsers).

export const users = { initialState, reducer };
